import React, { useRef, useState } from "react";
import { toast } from "sonner";
import { Button } from "@/components/ui/button";
import { Label } from "@/components/ui/label";
import { adminApi, mediaUrl } from "@/lib/api";

export const ImageField = ({ label, value, onChange, testId }) => {
  const inputRef = useRef(null);
  const [uploading, setUploading] = useState(false);

  const handle = async (e) => {
    const f = e.target.files?.[0];
    if (!f) return;
    if (f.size > 5 * 1024 * 1024) {
      toast.error("Image must be 5MB or smaller.");
      e.target.value = "";
      return;
    }
    setUploading(true);
    try {
      const fd = new FormData();
      fd.append("file", f);
      const res = await adminApi.post("/admin/media", fd);
      onChange(res.data.url);
      toast.success("Image uploaded");
    } catch (err) {
      toast.error(err?.response?.data?.detail || "Upload failed");
    } finally {
      setUploading(false);
      e.target.value = "";
    }
  };

  return (
    <div className="space-y-2">
      <Label className="text-xs uppercase tracking-wider text-neutral-500">{label}</Label>
      <div className="flex items-center gap-3">
        {value ? (
          <img src={mediaUrl(value)} alt={label} className="h-14 w-14 object-cover border border-neutral-200 bg-neutral-50" />
        ) : (
          <div className="h-14 w-14 border border-dashed border-neutral-300 bg-neutral-50" />
        )}
        <div className="flex flex-col gap-1.5">
          <input ref={inputRef} type="file" accept=".jpg,.jpeg,.png,.webp" className="hidden" onChange={handle} data-testid={testId} />
          <Button type="button" variant="outline" size="sm" disabled={uploading} onClick={() => inputRef.current?.click()} data-testid={`${testId}-btn`}>
            {uploading ? "Uploading…" : value ? "Replace image" : "Upload image"}
          </Button>
          {value && (
            <button type="button" className="text-left text-xs text-red-700 hover:underline" onClick={() => onChange("")}>
              Remove
            </button>
          )}
        </div>
      </div>
    </div>
  );
};
